function ViewIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#00AAB0" />
      <path
        d="M16.8 9.71287V10.0223C16.7347 10.2795 16.579 10.4782 16.409 10.668C16.2367 10.8606 16.0683 11.0573 15.8907 11.2443C15.031 12.1486 14.0827 12.9319 12.972 13.4889C12.137 13.9077 11.2603 14.1466 10.3253 14.1329C9.271 14.1174 8.30633 13.7835 7.39733 13.2564C6.28933 12.6142 5.346 11.7638 4.49967 10.7929C4.29767 10.5611 4.078 10.3404 4 10.0227V9.71321C4.05967 9.51929 4.14767 9.34324 4.28667 9.19505C4.67433 8.78141 5.04233 8.34543 5.45033 7.95449C6.36733 7.07564 7.39167 6.36355 8.583 5.93238C9.31967 5.66557 10.0767 5.54797 10.856 5.62156C11.7533 5.70614 12.5827 6.01559 13.3667 6.46258C14.5103 7.11415 15.48 7.98543 16.342 8.99046C16.5287 9.20811 16.7283 9.41785 16.8 9.71321V9.71287ZM10.3997 12.7128C11.923 12.7132 13.1557 11.442 13.1563 9.86897C13.157 8.2966 11.9253 7.02578 10.4003 7.02578C8.87533 7.02578 7.64333 8.29626 7.64367 9.86862C7.644 11.4413 8.87567 12.7128 10.3993 12.7132L10.3997 12.7128Z"
        fill="white"
      />
      <path
        d="M12.3719 9.86585C12.3729 10.9854 11.4869 11.9017 10.4026 11.9027C9.31789 11.9041 8.42922 10.9898 8.42822 9.871C8.42689 8.75147 9.31289 7.83549 10.3976 7.83377C11.4822 7.8324 12.3712 8.747 12.3722 9.8655L12.3719 9.86585Z"
        fill="white"
      />
    </svg>
  );
}

export { ViewIcon };
